import React from 'react';
import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import authStore from '../../stores/authStore';
import PhoneAuth from './PhoneAuth';


export default function LoginForm() {

    const store = authStore();
    const navigate = useNavigate(); // this is a react hook
    const [showError, setShowError] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        const res = await store.login();
        console.log("Login response:", res);

        if (res==="error") {
            setShowError(true);
        } else {
            setShowError(false);
        }
        
        // Navigate
        navigate("/");
    };

    return (
        <div>
            <div className="loginForm">
                {/* <div>
                    <PhoneAuth></PhoneAuth>
                </div> */}
                <form onSubmit={handleLogin}>
                    <label>Email address</label>
                    <input onChange={store.updateLoginForm} value={store.loginForm.email} type="email" name="email"/><br/>
                    <label>Password</label>
                    <input onChange={store.updateLoginForm} value={store.loginForm.password} type="password" name="password"/>
                    <p className="termsMessage"></p>
                    {showError && (
                        <p className="loginErrorBlurb">Error!</p>
                    )}
                    <button type="submit">Log in</button>
                </form>
                
            </div>
            <div>
                <p className="termsMessage">Forgot password?<br/>Email projscoped@gmail.com</p>
            </div>  
        </div>
    )
}